const LabelIcon = ({ ...props }) => {
  return (
    <svg
      viewBox="0 0 13 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11.1944 0.166504H7.15354C6.88623 0.166504 6.51262 0.321367 6.32375 0.510096L0.783711 6.05016C0.40543 6.42802 0.40543 7.04752 0.783711 7.42493L4.90872 11.5498C5.28614 11.9277 5.90505 11.9277 6.28304 11.5494L11.8231 6.0102C12.0118 5.82149 12.1667 5.44728 12.1667 5.18054V1.13878C12.1667 0.604148 11.729 0.166504 11.1944 0.166504ZM9.24985 4.05545C8.71289 4.05545 8.27759 3.61969 8.27759 3.08318C8.27759 2.54579 8.71289 2.11091 9.24985 2.11091C9.78681 2.11091 10.2223 2.54579 10.2223 3.08318C10.2223 3.61969 9.78681 4.05545 9.24985 4.05545Z" />
    </svg>
  );
};

export default LabelIcon;
